import { cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../handlers/cn.utils";

const badgeVariants = cva("inline-flex items-center rounded-sm px-2.5 py-0.5 text-xs font-medium transition-colors", {
	variants: {
		variant: {
			default: "border-transparent bg-gray-100 text-gray-800",
			secondary: "border-transparent bg-secondary text-secondary-foreground",
			destructive: "border-transparent bg-destructive text-destructive-foreground",
			outline: "border border-gray-200 text-gray-800",
			open: "border-transparent bg-interviewStage-hired text-interviewStage-hired-text",
			closed: "border-transparent bg-interviewStage-rejected text-interviewStage-rejected-text",
			onhold: "border-transparent bg-interviewStage-screening text-interviewStage-screening-text",
		},
	},
	defaultVariants: {
		variant: "default",
	},
});

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
	return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
});

Badge.displayName = "Badge";

export { Badge, badgeVariants };
